import { MutableRefObject, useEffect, useState } from "react";
import { useMorph } from "react-morph";
import Draggable from "react-draggable";
import React from "react";
import {
  base,
  conference_proceedings,
  knowledge_base,
  mine_sites,
} from "../../data";
import { ChatContextType } from "../../contexts/ChatContext/ChatContextType";
import { ChatContext } from "../../contexts/ChatContext/ChatContextProvider";
import FilterPill from "../filterpill/filterpill";
import ImageFilterPill from "../imagefilterpill/imagefilterpill";
import { SearchType } from "../../enums/SearchTypes";
import { FilterScope } from "../../enums/FilterScope";
import { v4 as uuidv4 } from "uuid";

interface ChatQuestionDockProps {
  FollowUpQuestions: string[];
  callback: (value: string) => void;
  abortControllerRef: MutableRefObject<AbortController>[];
  setQuestionId: (value: string) => void;
}

const ChatQuestionDock: React.FC<ChatQuestionDockProps> = ({
  FollowUpQuestions,
  callback,
  abortControllerRef,
  setQuestionId,
}) => {
  const chatContext = React.useContext<ChatContextType | null>(ChatContext);
  const [allSelected, setAllSelected] = useState<boolean>(
    chatContext ? chatContext!.allSelected : true
  );
  const [inputValue, setInputValue] = useState<string>("");
  const [submitReady, setSubmitReady] = useState<boolean>(false);
  const [appliedFilters, setAppliedFilters] = useState<string[]>(
    chatContext ? chatContext!.indexes : []
  );
  const [filterScope, setFilterScope] = useState<FilterScope>();

  const [openFilters, setOpenFilters] = useState<string[]>([]);
  useEffect(() => {
    if (inputValue.trim().length > 0) {
      setSubmitReady(true);
    } else {
      setSubmitReady(false);
    }
  }, [inputValue]);

  const handleUserChange = (value: string) => {
    setInputValue(value);
  };

  const [toggle, setToggle] = useState(false);
  const morph = useMorph();

  const addToAppliedFilters = (value: string, startFresh: boolean) => {
    let newFilters = [...appliedFilters];

    if (startFresh) {
      newFilters = [];
    }

    const newValues = value.split(",");

    newValues.forEach((newValue) => {
      const index = newFilters.indexOf(newValue, 0);
      if (index < 0) {
        newFilters.push(newValue);
      }
    });

    setAppliedFilters(newFilters);
    // chatContext?.saveIndexes(newFilters);
  };

  const removeFromAppliedFilters = (value: string) => {
    const newFilters = [...appliedFilters];

    const newValues = value.split(",");
    newValues.forEach((newValue) => {
      do {
        const index = newFilters.indexOf(newValue, 0);
        if (index > -1) {
          newFilters.splice(index, 1);
        }
      } while (newFilters.indexOf(newValue, 0) > -1);
    });

    if (newFilters.length < 1) {
      setAppliedFilters(base.map((item) => item.indexName));
      chatContext?.saveAllSelected(true);
      setAllSelected(true);
    } else {
      setAppliedFilters(newFilters);
    }
    // chatContext?.saveIndexes(newFilters);
  };

  const saveFilterScope = (scope: FilterScope) => {
    //chatContext?.saveFilterScope(scope);
    setFilterScope(scope);
  };

  return (
    <>
      {!toggle && (
        <div className="fixed bottom-8 right-8 overflow-hidden">
          <div {...morph} className=" bg-red drop-shadow-xl">
            <button
              type="button"
              className="flex w-[40px] h-[40px]"
              onClick={() => setToggle(!toggle)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-white m-auto "
              >
                <path
                  d="M5.22094 11.1125C5.42511 11.2567 5.66844 11.3333 5.91761 11.3325V11.3292C6.15287 11.3298 6.38312 11.2612 6.57974 11.132C6.77635 11.0028 6.93065 10.8187 7.02344 10.6025L7.53428 9.04917C7.65219 8.69725 7.8504 8.3776 8.1132 8.11552C8.37601 7.85343 8.6962 7.65611 9.04844 7.53917L10.5301 7.0575C10.7692 6.97407 10.9758 6.81723 11.1205 6.60939C11.2651 6.40155 11.3404 6.15332 11.3356 5.90014C11.3308 5.64695 11.2462 5.40176 11.0937 5.19956C10.9413 4.99735 10.7289 4.84847 10.4868 4.77417L9.02428 4.29917C8.67059 4.18128 8.34923 3.98261 8.08568 3.71891C7.82213 3.45522 7.62364 3.13375 7.50594 2.78L7.02428 1.29917C6.94028 1.06331 6.78489 0.85948 6.57972 0.715992C6.37455 0.572505 6.12978 0.496488 5.87942 0.498504C5.62906 0.50052 5.38555 0.580469 5.18272 0.727242C4.97988 0.874016 4.8278 1.08032 4.74761 1.3175L4.26178 2.81083C4.14446 3.1543 3.95077 3.46668 3.69529 3.72448C3.4398 3.98227 3.12917 4.17876 2.78678 4.29917L1.30594 4.77417C1.06827 4.85641 0.862338 5.01105 0.717083 5.21636C0.571829 5.42167 0.494554 5.66733 0.496117 5.91883C0.49768 6.17032 0.578003 6.41501 0.725798 6.6185C0.873594 6.82199 1.08143 6.97406 1.32011 7.05333L2.78178 7.5275C3.13542 7.64622 3.45665 7.84547 3.72014 8.10954C3.98362 8.3736 4.18217 8.69527 4.30011 9.04917L4.78178 10.5283C4.86428 10.7642 5.01761 10.9683 5.22094 11.1125ZM4.90928 7.57C4.81646 7.44848 4.71539 7.33348 4.60678 7.22583H4.60928C4.20674 6.82329 3.71601 6.52001 3.17594 6.34L1.84261 5.91667L3.18511 5.48C3.71639 5.29605 4.19825 4.99239 4.59344 4.5925C4.98688 4.19003 5.28354 3.7033 5.46094 3.16917L5.89011 1.85083L6.32011 3.17333C6.49989 3.71231 6.80301 4.20187 7.20535 4.60305C7.60768 5.00423 8.09812 5.30594 8.63761 5.48417L9.98761 5.91917L8.66261 6.34833C8.12402 6.5275 7.63463 6.82982 7.23334 7.23125C6.83205 7.63269 6.52992 8.12218 6.35094 8.66083L5.92178 9.97917L5.49261 8.65833C5.36109 8.26519 5.16385 7.89719 4.90928 7.57ZM11.6101 15.3175C11.4511 15.2042 11.3316 15.0439 11.2684 14.8592L10.9951 14.0208C10.9421 13.8613 10.8527 13.7162 10.734 13.5972C10.6152 13.4781 10.4704 13.3884 10.3109 13.335L9.48511 13.0658C9.2962 13.0018 9.13196 12.8805 9.0153 12.7187C8.89863 12.5569 8.83535 12.3628 8.83428 12.1633C8.83404 11.965 8.89586 11.7716 9.01108 11.6102C9.12631 11.4488 9.28915 11.3275 9.47678 11.2633L10.3151 10.9917C10.471 10.9363 10.6122 10.8458 10.7278 10.7274C10.8433 10.6089 10.9302 10.4656 10.9818 10.3083L11.2518 9.4825C11.3153 9.29564 11.4353 9.13312 11.5952 9.01741C11.7551 8.90171 11.947 8.83853 12.1443 8.8366C12.3417 8.83468 12.5348 8.89411 12.6969 9.00669C12.859 9.11926 12.9821 9.27941 13.0493 9.465L13.3234 10.31C13.3771 10.4684 13.4668 10.6122 13.5853 10.7302C13.7039 10.8482 13.8481 10.9371 14.0068 10.99L14.8334 11.2592C15.024 11.3188 15.191 11.4368 15.3107 11.5967C15.4304 11.7565 15.4967 11.9499 15.5003 12.1495C15.5039 12.3492 15.4446 12.5449 15.3307 12.7089C15.2168 12.8729 15.0542 12.9969 14.8659 13.0633L14.0209 13.3375C13.8621 13.3911 13.7178 13.4809 13.5995 13.5998C13.4812 13.7186 13.3921 13.8634 13.3393 14.0225L13.0709 14.8467C13.0059 15.0383 12.8826 15.205 12.7168 15.3217C12.555 15.4367 12.3613 15.4981 12.1628 15.4974C11.9643 15.4966 11.771 15.4337 11.6101 15.3175ZM10.7518 12.165C11.0788 12.2822 11.3756 12.471 11.6204 12.7175C11.8652 12.964 12.0519 13.2621 12.1668 13.59C12.2829 13.2635 12.4703 12.9669 12.7153 12.7219C12.9604 12.4768 13.2569 12.2894 13.5834 12.1733C13.2538 12.0579 12.9541 11.8702 12.7063 11.6239C12.4586 11.3776 12.2691 11.079 12.1518 10.75C12.0371 11.0748 11.852 11.3702 11.6097 11.615C11.3673 11.8598 11.0738 12.0479 10.7501 12.1658"
                  fill="#FFFFFF"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
      <Draggable axis="both" handle="span" defaultPosition={{ x: 0, y: 0 }}>
        <div {...morph} className="fixed bottom-20 left-8 z-50">
          {toggle && (
            <div
              {...morph}
              className=" bg-[#F2F2F2] border-t-2 border-red grid grid-cols-1 gap-4 p-4 drop-shadow-lg rounded-b max-w-[460px]"
            >
              <div className="flex">
                <div className="flex-1 text-charcoal-dark font-semibold">
                  <span className="cursor-pointer">Find out more</span>
                </div>
                <div>
                  <button type="button" onClick={() => setToggle(!toggle)}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-red"
                    >
                      <path
                        d="M17.3332 1.84166L12.9248 6.25L15.6665 9H8.99984V2.33333L11.7415 5.075L16.1582 0.666664L17.3332 1.84166ZM1.8415 17.3333L6.24984 12.925L8.99984 15.6667V9H2.33317L5.07484 11.7417L0.666504 16.1583L1.8415 17.3333Z"
                        fill="#FF372F"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div>
                <div className="mb-2">
                  <div className="flex flex-row gap-2">
                    <div>
                      <button
                        type="button"
                        className={
                          chatContext?.searchType === SearchType.All
                            ? "px-2 py-4 font-semibold border-b-4 border-blue"
                            : "px-2 py-4 font-semibold"
                        }
                        onClick={() =>
                          chatContext?.saveSearchType(SearchType.All)
                        }
                      >
                        All
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        className={
                          chatContext?.searchType === SearchType.Images
                            ? "px-2 py-4 font-semibold border-b-4 border-blue"
                            : "px-2 py-4 font-semibold"
                        }
                        onClick={() =>
                          chatContext?.saveSearchType(SearchType.Images)
                        }
                      >
                        Images
                      </button>
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-light-gray-40 p-2">
                  <div>
                    <textarea
                      className="w-full resize-none text-charcoal-dark"
                      rows={5}
                      placeholder="Ask a follow up."
                      value={inputValue}
                      onChange={(e) => handleUserChange(e.target.value)}
                      onFocus={() => setOpenFilters([])}
                    ></textarea>
                  </div>
                  <div className="flex flex-row">
                    <div className="flex-1 flex flex-row text-xs gap-1">
                      <div>
                        <div className="flex flex-wrap gap-1">
                          <div className="flex my-auto">Filters:</div>

                          {/* All Resources */}
                          <div
                            className={
                              allSelected
                                ? "border border-blue bg-blue text-white rounded-full my-auto"
                                : "border border-blue rounded-full my-auto"
                            }
                          >
                            <button
                              type="button"
                              className="p-2"
                              onClick={() => {
                                setAllSelected(true);
                                chatContext?.saveAllSelected(true);
                                setAppliedFilters(
                                  base.map((item) => item.indexName + ",")
                                );
                              }}
                            >
                              All Resources
                            </button>
                          </div>

                          {/* Divider */}
                          <div className="border-r border-light-gray pl-1 mr-1 my-1"></div>

                          <FilterPill
                            pillname="WSP Documents"
                            data={mine_sites}
                            appliedFilters={appliedFilters}
                            addCallback={addToAppliedFilters}
                            removeCallback={removeFromAppliedFilters}
                            openFilters={openFilters}
                            setOpenFilters={setOpenFilters}
                            allSelected={allSelected}
                            setAllSelected={(value: boolean) => {
                              setAllSelected(value);
                              chatContext?.saveAllSelected(value);
                            }}
                          />

                          <FilterPill
                            pillname="Conference Proceedings"
                            data={conference_proceedings}
                            appliedFilters={appliedFilters}
                            addCallback={addToAppliedFilters}
                            removeCallback={removeFromAppliedFilters}
                            openFilters={openFilters}
                            setOpenFilters={setOpenFilters}
                            allSelected={allSelected}
                            setAllSelected={(value: boolean) => {
                              setAllSelected(value);
                              chatContext?.saveAllSelected(value);
                            }}
                          />

                          <FilterPill
                            pillname="Mining Knowledge Base"
                            data={knowledge_base}
                            appliedFilters={appliedFilters}
                            addCallback={addToAppliedFilters}
                            removeCallback={removeFromAppliedFilters}
                            openFilters={openFilters}
                            setOpenFilters={setOpenFilters}
                            allSelected={allSelected}
                            setAllSelected={(value: boolean) => {
                              setAllSelected(value);
                              chatContext?.saveAllSelected(value);
                            }}
                          />

                          {/* Divider */}
                          {chatContext?.searchType === SearchType.All && (
                            <div className="border-r border-light-gray pl-1 mr-1 my-1"></div>
                          )}

                          {chatContext?.searchType === SearchType.All && (
                            <ImageFilterPill
                              pillname="Image Filter Scope"
                              openFilters={openFilters}
                              setOpenFilters={setOpenFilters}
                              saveCallback={saveFilterScope}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="content-end">
                      <button
                        type="button"
                        className={
                          submitReady
                            ? "bg-blue text-white w-full p-2"
                            : "bg-disabled text-white w-full p-2"
                        }
                        disabled={!submitReady}
                        onClick={() => {
                          chatContext?.saveChatAndIndexes(
                            { question: inputValue.trim(), history: "" },
                            appliedFilters,
                            filterScope
                          );
                          setQuestionId(uuidv4().replaceAll("-", ""));
                          abortControllerRef.forEach(
                            (item) => (item.current = new AbortController())
                          );
                        }}
                      >
                        <svg
                          width="18"
                          height="16"
                          viewBox="0 0 18 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.925 3.025L8.18333 5.70833L1.91667 4.875L1.925 3.025ZM8.175 10.2917L1.91667 12.975V11.125L8.175 10.2917ZM0.258333 0.5L0.25 6.33333L12.75 8L0.25 9.66667L0.258333 15.5L17.75 8L0.258333 0.5Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Follow up Questions */}
              {/* <div className="flex flex-wrap gap-3">
                {FollowUpQuestions.map((value) => (
                  <button
                    key={value}
                    type="button"
                    className="flex bg-white border-b border-b-red text-left p-2"
                    onClick={() => setInputValue(value)}
                  >
                    <svg
                      width="16"
                      height="13"
                      viewBox="0 0 16 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="my-auto mr-2"
                    >
                      <path
                        d="M10.5 12.3333L9.33333 11.1458L12.3125 8.16667H4.25C3.20833 8.16667 2.32292 7.80209 1.59375 7.07292C0.864583 6.34375 0.5 5.45834 0.5 4.41667C0.5 3.37501 0.864583 2.48959 1.59375 1.76042C2.32292 1.03126 3.20833 0.666672 4.25 0.666672H4.66667V2.33334H4.25C3.66667 2.33334 3.17361 2.53473 2.77083 2.93751C2.36806 3.34028 2.16667 3.83334 2.16667 4.41667C2.16667 5 2.36806 5.49306 2.77083 5.89584C3.17361 6.29862 3.66667 6.5 4.25 6.5H12.3125L9.33333 3.50001L10.5 2.33334L15.5 7.33334L10.5 12.3333Z"
                        fill="#537898"
                      />
                    </svg>
                    {value}
                  </button>
                ))}
              </div> */}
            </div>
          )}
        </div>
      </Draggable>
    </>
  );
};

export default ChatQuestionDock;
